import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../components/Button";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import {
  closeModal,
  deleteImage,
  emailTemplatesList,
  gotoUrl,
} from "../../actions";

export class DeleteImageModal extends Component {
  constructor(props) {
    super(props);
    this.delete = this.delete.bind(this);
  }

  delete(e) {
    if (e) {
      e.preventDefault();
    }

    const { accountId, image } = this.props;

    this.props.deleteImage(accountId, image.id).then(this.props.closeModal);
  }

  render() {
    const { image } = this.props;
    const content = image?.name ? `Remove ${image.name}` : "Removing";

    return (
      <Modal>
        <ModalHeader>Delete Image?</ModalHeader>
        <ModalContent>{content}</ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button onClick={this.delete}>Delete</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

DeleteImageModal.propTypes = {
  deleteImage: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  gotoUrl: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const { accountId, id } = params;
  const image = state.entities.image[id];

  return {
    accountId,
    id,
    image,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  closeModal,
  deleteImage,
  emailTemplatesList,
  gotoUrl,
})(DeleteImageModal);
